import React from 'react'
import { useSelector } from 'react-redux'
import { useScenario } from '../queries/useScenario'
import { BudgetingScenario } from '../types/BudgetingScenario'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'

interface CtxScenarioNameProps {
  scenarioId?: BudgetingScenario['id']
}

const CtxScenarioName = ({ scenarioId }: CtxScenarioNameProps) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const scenario = useScenario({ companyId, scenarioId })
  return <span>{scenario?.name}</span>
}

export default CtxScenarioName
